import { UserScopes } from "./user_scopes";

export const PRODUCT_MAPPING = {
  "super peak": "Super Peak",
  "inverse solar": "Inverse Solar",
  "solar": "Solar",
  "cgeo": "C-GEO",
  "geo": "GEO",
  "ngeo": "N-GEO",
  "gs": "GS (VER)",
  "vcu": "VCU",
  "cer": "CER",
  "prc": "PRC",
  "acr": "ACR",
  "car": "CAR",
  "nzu": "NZU",
  "accu": "ACCU",
  "veec": "VEEC",
  "esc": "ESC",
  "stc": "STC",
  "lgc": "LGC",
  "flat": "Flat",
  "peak": "Peak",
  "off peak": "Off Peak",
  "cap300": "$300 Cap",
  "irec": "I-REC",
  "rego": "REGO",
  "rego-bb": "REGO-BB",
  "smc": "SMC",
  "mn": "Morning",
  "mp": "Morning Peak",
  "dy": "Daytime",
  "ev": "Evening",
  "ep": "Evening Peak",
  "nt": "Nighttime",
  "ht1h": "Heads & Tails 1 Hour",
  "ht2h": "Heads & Tails 2 Hour",
  "ht3h": "Heads & Tails 3 Hour",
  "ht4h": "Heads & Tails 4 Hour",
  "ht8h": "Heads & Tails 8 Hour"
} as const;

// Product codes whose `core.product.<segment>.read` scope segment does not
// match the code itself, so they cannot be resolved off PRODUCT_MAPPING.
export const productScopeSegmentToCode = {
  "morning": "mn",
  "morning-peak": "mp",
  "daytime": "dy",
  "evening": "ev",
  "evening-peak": "ep",
  "nighttime": "nt",
  "heads-and-tails-1h": "ht1h",
  "heads-and-tails-2h": "ht2h",
  "heads-and-tails-3h": "ht3h",
  "heads-and-tails-4h": "ht4h",
  "heads-and-tails-8h": "ht8h"
}

export const headsAndTailsScope = {
  "heads-and-tails-1h": "ht1h",
  "heads-and-tails-2h": "ht2h",
  "heads-and-tails-3h": "ht3h",
  "heads-and-tails-4h": "ht4h",
  "heads-and-tails-8h": "ht8h"
} as const;

export type Code = keyof typeof PRODUCT_MAPPING;
export type Name = typeof PRODUCT_MAPPING[Code];

export type ProductCurrency = "AUD" | "USD" | "NZD";

export type ProductShape =
  | "mn" | "mp" | "dy" | "ep" | "ev" | "nt"
  | "flat" | "solar" | "inverse solar" | "super peak"
  | "peak" | "off peak"
  | "ht1h" | "ht2h" | "ht3h" | "ht4h" | "ht8h"
  | null;

export type ProductClass =
  | "au-heads-and-tails"
  | "au-hourly-shapes"
  | "au-heads-and-tails"
  | "carbon"
  | "environmental"
  | "electricity"
  | "power"
  | "rehub";

export type ProductType = {
  code: Code;
  name: Name;
  market: number;
  currency: ProductCurrency;
  certificate: string | null;
  shape: ProductShape | null;
  marketPricesSortOrder: number | null;
  dailyCurvesSortOrder: number | null;
  greenMarketplaceSortOrder: number | null;
  longName: string;
  marketPricesCustomerVisible: boolean;
  dailyCurvesCustomerVisible: boolean;
  greenMarketplaceCustomerVisible: boolean;
  dailyCurvesMethodspecificCustomerVisible: boolean;
  earliestVintage: number | null;
  productClass: ProductClass;
  showSpotInName: boolean;
  showNonmethodspecificMarketPrices: boolean;
  dailyCurvesHasNonmethodspecificCurve: boolean;
  bezeroAccreditor: string | null;
  requiredScope?: UserScopes;
};
